import Vue from 'vue'

Vue.filter('fhNumber', function (value, fractionDigits = 0, thousandSeperator = '.', fractionSeperator = ',') {
  if (typeof value !== 'number') {
    return value
  }
  // return new Intl.NumberFormat('de-DE').format(value)
  if (value!==0 && !value || !Number.isFinite(value)) return value
    const frDigits = Number.isFinite(fractionDigits)? Math.min(Math.max(fractionDigits, 0), 7) : 0
    const num = value.toFixed(frDigits).toString()

    const parts = num.split('.')
    let digits = parts[0].split('').reverse()
    let sign = ''
    if (num < 0) {sign = digits.pop()}
    let final = []
    let pos = 0

    while (digits.length > 1) {
        final.push(digits.shift())
        pos++
        if (pos % 3 === 0) {final.push(thousandSeperator)}
    }
    final.push(digits.shift())
    return `${sign}${final.reverse().join('')}${frDigits > 0 ? fractionSeperator : ''}${frDigits > 0 && parts[1] ? parts[1] : ''}`
})

Vue.filter('fhIntegerNumber', function (value, fractionDigits = 0, thousandSeperator = '.', fractionSeperator = ',') {
  if (typeof value !== 'number') {
    return value
  }
  // return new Intl.NumberFormat('de-DE', {maximumFractionDigits: 0}).format(value)
  if (value!==0 && !value || !Number.isFinite(value)) return value
    const frDigits = Number.isFinite(fractionDigits)? Math.min(Math.max(fractionDigits, 0), 7) : 0
    const num = value.toFixed(frDigits).toString()

    const parts = num.split('.')
    let digits = parts[0].split('').reverse()
    let sign = ''
    if (num < 0) {sign = digits.pop()}
    let final = []
    let pos = 0

    while (digits.length > 1) {
        final.push(digits.shift())
        pos++
        if (pos % 3 === 0) {final.push(thousandSeperator)}
    }
    final.push(digits.shift())
    return `${sign}${final.reverse().join('')}${frDigits > 0 ? fractionSeperator : ''}${frDigits > 0 && parts[1] ? parts[1] : ''}`
})

Vue.filter('fhDecimalNumber', function (value, fractionDigits =  2, thousandSeperator = '.', fractionSeperator = ',') {
  if (typeof value !== 'number') {
    return value
  }
  // return new Intl.NumberFormat('de-DE', {maximumFractionDigits: fractionDigits, minimumFractionDigits: fractionDigits}).format(value)
  if (value!==0 && !value || !Number.isFinite(value)) return value
    const frDigits = Number.isFinite(fractionDigits)? Math.min(Math.max(fractionDigits, 0), 7) : 0
    const num = value.toFixed(frDigits).toString()

    const parts = num.split('.')
    let digits = parts[0].split('').reverse()
    let sign = ''
    if (num < 0) {sign = digits.pop()}
    let final = []
    let pos = 0

    while (digits.length > 1) {
        final.push(digits.shift())
        pos++
        if (pos % 3 === 0) {final.push(thousandSeperator)}
    }
    final.push(digits.shift())
    return `${sign}${final.reverse().join('')}${frDigits > 0 ? fractionSeperator : ''}${frDigits > 0 && parts[1] ? parts[1] : ''}`
})

Vue.filter('fhDate',
  /** @param {string} value  */
  function (value) {
    if (!value) return value

    return value.split('T')[0].split('-').reverse().join('/')
  }
)

Vue.filter('fhCuenta',

  function (value) {
    if (!value) return value
    let cuenta = value.toString()
    if (cuenta.length < 2) return cuenta
    return cuenta.substring(0,cuenta.length-2) + '-' + cuenta.substring(cuenta.length-2,cuenta.length)
  }
)

